/**
 * @generated SignedSource<<87836bfa0bfac68de6ceb6f2c1267add>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserLanguage = "AR" | "DE" | "EN" | "ES" | "FR" | "IT" | "PL" | "TR";
export type OnboardBusinessUserInput = {
  email?: string | null | undefined;
  risk?: ReadonlyArray<BusinessUserRisks> | null | undefined;
  termsAndConditions?: ReadonlyArray<string> | null | undefined;
};
export type BusinessUserRisks = {
  answerId: string;
  questionId: string;
};
export type OnboardBusinessUserMutation$variables = {
  input?: OnboardBusinessUserInput | null | undefined;
};
export type OnboardBusinessUserMutation$data = {
  readonly onboardBusinessUser: {
    readonly active?: boolean;
    readonly approved?: boolean;
    readonly id: string;
    readonly language: UserLanguage;
    readonly onboarded: boolean;
    readonly tradingActive?: boolean;
    readonly withdrawalsActive: boolean;
  } | null | undefined;
};
export type OnboardBusinessUserMutation = {
  response: OnboardBusinessUserMutation$data;
  variables: OnboardBusinessUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboarded",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "withdrawalsActive",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradingActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    }
  ],
  "type": "BusinessUser",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardBusinessUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "onboardBusinessUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardBusinessUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "onboardBusinessUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1cd6ef67d9bb907d9fbc2e5ce50ea4ba",
    "id": null,
    "metadata": {},
    "name": "OnboardBusinessUserMutation",
    "operationKind": "mutation",
    "text": "mutation OnboardBusinessUserMutation(\n  $input: OnboardBusinessUserInput\n) {\n  onboardBusinessUser(input: $input) {\n    __typename\n    id\n    onboarded\n    language\n    withdrawalsActive\n    ... on BusinessUser {\n      tradingActive\n      approved\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "16a61a00238dcb75c1da21566204dbe8";

export default node;
